import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './skstyle.css';
import './vkstyle.css';
import './sgstyle.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../src/redux/store';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "react-toastify/dist/ReactToastify.css";
//login
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from "react-toastify";


import "primereact/resources/primereact.min.css";

import "primeicons/primeicons.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={"669631342122-j8fti25uh9oqeumbb3kdkti5rhua1tsk.apps.googleusercontent.com"}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer position="top-right" autoClose={2000} />
      </BrowserRouter>

    </Provider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);


reportWebVitals();
